// src/api/activityApi.js
import axios from 'axios';
import endpoints from '../endpoints'

export const fetchHomeVideo = async () => {
    const response = await axios.get(endpoints.homeVideo);
    return response.data;
};